module.exports = __webpack_public_path__ + "static/media/1-7.09f9f13f.PNG";